import React, { useState, useEffect } from "react";
import axios from "axios";
import { CDCard, CDCardContent, CDCardHeader } from "../../const/CDCardStyles";
import {
  getDispositivisPaginated,
  exportDevices,
  getCallTypes,
} from "../../const/CardDati";
import { DispositiviHeader } from "../../const/DatatableData";
import { Grid, Divider, Typography } from "@mui/material";
import { DataGrid, GridOverlay } from "@mui/x-data-grid";
import { styled } from "@mui/material/styles";
import CheckValidSortModel from "../../functions/CheckValidSortModel";
import TableToolbar from "../UI/TableToolbar/TableToolbar";
import { useDispatch, useSelector } from "react-redux";
import { notificationOpen } from "../../redux/reducers/notification-reducer";
import Notification from "../UI/Notification/Notification";
import AdvancedFilterPanel from "./AdvancedFilterPanel";
import { openEmptyDialog } from "../../redux/reducers/dialogDispositivo-reducer";
import DialogCustom from "../UI/Dialog/DialogDevice";
import { loadListTypeCallState } from "../../redux/reducers/typeCallSlice-reducer";
import handlerError from "../../functions/handlerError";
import { formatDate } from "../../functions/formatDate";

const urlBase = process.env.REACT_APP_URL;
const columns = DispositiviHeader.headers;

const StyledDataGrid = styled(DataGrid)(() => ({
  "& .MuiDataGrid-columnHeader:focus": {
    outline: "none",
  },
  "& .MuiDataGrid-columnHeader:focus-within": {
    outline: "none",
  },
  "& .MuiDataGrid-root": {
    outline: "none !important",
  },
  "& .MuiDataGrid-cell:focus-within": {
    outline: "none !important",
  },
}));

const typePage = "Dispositivi";

const DispositiviDatatable = () => {
  const reloading = useSelector((state) => state.dataTableDispositivo);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rows, setRows] = useState([]);
  const [rowsCount, setRowsCount] = useState(rows.length);
  const [loading, setLoading] = useState(false);
  const [sortModel, setSortModel] = useState([
    {
      field: DispositiviHeader.intialFieldName,
      sort: DispositiviHeader.initialFieldOrder,
    },
  ]);
  const [filterParameters, setFilterParameters] = useState({
    radioRecoveryEnabled: null,
    radioDeviceEnabled: null,
    callType: [],
  });
  const [searchFilter, setSearchFilter] = useState("");
  const dispatch = useDispatch();
  const { sortField, sortOrder } = CheckValidSortModel(
    sortModel,
    DispositiviHeader.intialFieldName
  );

  const handleFilterData = (
    radioRecoveryEnabled,
    radioDeviceEnabled,
    selectedCallTypes
  ) => {
    let callTypesToView = [];
    selectedCallTypes.map((callType) => callTypesToView.push(callType.id));

    let newFilterParameters = {
      radioRecoveryEnabled: JSON.parse(radioRecoveryEnabled),
      radioDeviceEnabled: JSON.parse(radioDeviceEnabled),
      callType: callTypesToView,
    };

    setFilterParameters(newFilterParameters);
  };

  const handleSearchFilter = (value) => {
    setSearchFilter(value);
  };

  const handleDownloadXLS = () => {
    const { sortField, sortOrder } = CheckValidSortModel(sortModel, DispositiviHeader.initialFieldName);
    const { action, method } = exportDevices;
    const { radioRecoveryEnabled, radioDeviceEnabled, callType } = filterParameters;
    let url = urlBase + action;

    const requestBody = {
      pageIndex: page,
      pageSize: pageSize,
      sortColumnName: sortField,
      sortDirection: sortOrder,
      applyPaginationAndSort: true,
      searchFilter: searchFilter,
      radioRecoveryEnabled: radioRecoveryEnabled,
      radioDeviceEnabled: radioDeviceEnabled,
      callType: callType,
    };

    (async() => {
      try{
        const response = await axios({
          method: method,
          url,
          data: requestBody,
          responseType: "blob",
        })
        
        const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const blob = new Blob([response.data], { type: contentType });
        const urlDownload = window.URL.createObjectURL(blob);

        let a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = urlDownload;
        a.download = "Export-Dispositivi-" + formatDate(new Date());
        a.click();
        window.URL.revokeObjectURL(url);

      } catch(error){
        console.error(error);
        const notificationError = handlerError(error)
        dispatch(notificationOpen(notificationError))
      }
    })();
  };

  useEffect(() => {
    (async () => {
      setLoading(true);

      const { radioRecoveryEnabled, radioDeviceEnabled, callType } =
        filterParameters;

      const requestBody = {
        pageIndex: page,
        pageSize: pageSize,
        sortColumnName: sortField,
        sortDirection: sortOrder,
        applyPaginationAndSort: true,
        searchFilter: searchFilter,
        radioRecoveryEnabled: radioRecoveryEnabled,
        radioDeviceEnabled: radioDeviceEnabled,
        callType: callType,
      };

      const { action, method } = getDispositivisPaginated;
      let url = urlBase + action;
      try {
        const response = await axios({
          method: method,
          url,
          data: requestBody,
        });
        const newRows = response.data.result.result;
        const newRowsCount = response.data.result.totalFiltered;
        setRows(newRows);
        setRowsCount(newRowsCount);
        if (!response.data.ok) {
          dispatch(
            notificationOpen({
              message: response.data.message,
              status: response.data.ok,
            })
          );
        }
      } catch (error) {
        console.error(error);
        const notificationError = handlerError(error);
        dispatch(notificationOpen(notificationError));
      }
      setLoading(false);
    })();
  }, [page, pageSize, sortModel, searchFilter, reloading, filterParameters]);

  useEffect(() => {
    (async () => {
      const { action, method } = getCallTypes;
      let url = urlBase + action;
      const requestBody = {};
      try {
        const response = await axios({
          method: method,
          url,
          data: requestBody,
        });
        if (response.data.ok) {
          dispatch(loadListTypeCallState(response.data.result));
        }
      } catch (error) {
        console.error(error);
        const notificationError = handlerError(error);
        dispatch(notificationOpen(notificationError));
      }
    })();
  }, []);

  return (
    <>
      <Grid container item>
          <Grid item component={CDCard} xs={12} sm={12}>
              <CDCardHeader title="Elenco Dispositivi" />
              <Divider />
              <CDCardContent>
                <AdvancedFilterPanel handleFilterData={handleFilterData} />
                <Divider sx={{mb:2}}/>
                <Grid container item>
                  <StyledDataGrid
                      rows={rows}
                      rowCount={rowsCount}
                      getRowId={(row) => row.id}
                      columns={columns}
                      page={page}
                      pageSize={pageSize}
                      onPageChange={(newPage) => setPage(newPage)}
                      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                      onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                      rowsPerPageOptions={[ 10, 25, 50, 100]}
                      disableSelectionOnClick
                      sortModel={sortModel}
                      sortingMode='server'
                      sortingOrder={['asc', 'desc']}
                      paginationMode='server'
                      loading={loading}
                      sx={{border: 0}}
                      isCellEditable={() =>  false}
                      isRowSelectable={() => false}
                      disableColumnMenu
                      disableColumnFilter
                      disableColumnSelector
                      autoHeight
                      autoWidth
                      components={{
                        Toolbar: () => <TableToolbar typePage={typePage} 
                                                     startSearch={handleSearchFilter}
                                                     downloadXLS={handleDownloadXLS}
                                                     initialSearchText={searchFilter}
                                                     enableSearch={true}
                                                     enableAdd={true}
                                                     enableExport={true}
                                                     handleAdd={() => {dispatch(openEmptyDialog("add"))}}/>,
                        NoRowsOverlay: () => <GridOverlay>
                                               <Typography>Nessuna riga</Typography>
                                             </GridOverlay>,
                        NoResultsOverlay: () => <GridOverlay>
                                                  <Typography>Nessuna riga</Typography>
                                                </GridOverlay>
                      }}
                    />
                </Grid>
           </CDCardContent>
          </Grid>
        </Grid>
      <Notification />
      <DialogCustom />
    </>
  );
};

export default DispositiviDatatable;
